/*
 * Ansicht der Sammlungsseite wechseln, ohne die Seite neu zu laden
 * (Alex, Pastel #16, Nachfass 23.09.: "is it possible to change the view without reloading the entire page?").
 *
 * Die dichte Ansicht liegt auf einem eigenen Template (templates/collection.dense.json, ?view=dense).
 * Die Section Rendering API kann nur Sections des AKTUELLEN Templates liefern - darum wird die Zielseite
 * ganz geholt und daraus nur der Inhalt derselben Section uebernommen. Das ist eine Anfrage wie vorher,
 * aber ohne Neuaufbau von Kopf, Fuss und Skripten.
 *
 * Ohne JavaScript bleiben die Knoepfe normale Links - der Wechsel laedt dann wie bisher neu.
 * Bei jedem Fehler (Netz, unerwartete Antwort) faellt der Klick auf den normalen Seitenwechsel zurueck.
 */
(function () {
  if (window.__skogCollectionView) return;
  window.__skogCollectionView = true;

  var loading = false;

  function sectionOf(el) {
    return el.closest('[id^="shopify-section-"]');
  }

  function swap(url, push) {
    var host = document.querySelector('.collection');
    var section = host && sectionOf(host);
    if (!section) { window.location.href = url; return; }
    if (loading) return;
    loading = true;

    var grid = section.querySelector('.collection__grid');
    if (grid) grid.style.opacity = '0';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(section.id) || doc.querySelector('.collection');
        if (!fresh) throw new Error('Section nicht gefunden');
        if (fresh.id !== section.id) fresh = sectionOf(fresh) || fresh;
        section.innerHTML = fresh.innerHTML;
        if (push) window.history.pushState({ skogCollectionView: true }, '', url);
        document.dispatchEvent(new CustomEvent('skog:collection:view', { detail: { url: url } }));
        loading = false;
      })
      .catch(function () {
        loading = false;
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.collection__view-btn');
    if (!link || link.classList.contains('is-active')) return;
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== 0) return;
    event.preventDefault();
    swap(link.href, true);
  });

  window.addEventListener('popstate', function (event) {
    if (!event.state || !event.state.skogCollectionView) return;
    swap(window.location.href, false);
  });
})();
